import styled from 'styled-components';

export const Section = styled.section`
  .intro {
    padding: 0 2rem;
  }
`;
